import Button from "./Button";
import Card from "./Card";
import "./CardsCloud.css";
import { ReactComponent as FourPointsNarrow } from "./static/icons/FourPointsNarrow.svg";
import { ReactComponent as Atom } from "./static/icons/Atom.svg";
import { useState } from "react";

function getXCoordinate() {
  return Math.random() * 550;
}

function getYCoordinate() {
  return Math.random() * 500;
}

function CardsCloud({ cardTexts }) {
  const [refresh, setRefresh] = useState(false);
  let cardCoordinates = []; // [{x: 12, y: 32}, {x: 42, y: 12}, ...]
  const MAX_TRIES = 1000;
  const CARD_DIMENSIONS = { x: 425, y: 130 };

  function getRandomCoords(tries) {
    if (tries > MAX_TRIES) {
      return undefined;
    }
    const x = getXCoordinate(); //WHAT COORDINATE RETURNS BECOMES VALUE X
    const y = getYCoordinate();
    if (overlapping({ x, y }, cardCoordinates)) {
      //IF THE COORDS ARE OVERLAPPING THE FUNCTION CALLS ITSELF AND TRIES HARDER
      return getRandomCoords(tries + 1);
    }
    return { x, y };
  }

  function overlapping(pos, cardCoordinates) {
    for (const cardCoordinate of cardCoordinates) {
      if (
        Math.abs(cardCoordinate.y - pos.y) < CARD_DIMENSIONS.y &&
        Math.abs(cardCoordinate.x - pos.x) < CARD_DIMENSIONS.x
      ) {
        return true;
      }
    }
    return false;
  }

  function getAllCardPositions(shuffles) {
    if (shuffles > MAX_TRIES) {
      return;
    }
    for (let i in cardTexts) {
      //by checking cardText we know how many cards which is the i.
      //FOR EVERY CARD WE HAVE WE DO SOMETHING:
      const pos = getRandomCoords(0);
      if (pos === undefined) {
        break;
      }
      cardCoordinates.push(pos);
    }

    if (cardTexts.length !== cardCoordinates.length) {
      //IF WE DON'T HAVE A COORD FOR EACH CARD
      cardCoordinates = [];
      getAllCardPositions(shuffles + 1); //DO IT AGAIN AND TRY HARDER
    }
  }

  getAllCardPositions(0);

  return (
    <div>
      <div style={{ height: 600 }}>
        {cardTexts.map((cardText, i) => {
          if (!cardCoordinates[i]) {
            return;
          }
          return (
            <Card
              variant="small"
              text={cardText}
              icon={<FourPointsNarrow />}
              x={cardCoordinates[i].x}
              y={cardCoordinates[i].y}
            />
          );
        })}
      </div>
      <Button
        className="ShuffleButton"
        variant="complex"
        text="SHUFFLE CARDS"
        icon={<Atom />}
        onClick={() => setRefresh(!refresh)}
      />
    </div>
  );
}

export default CardsCloud;
